import { render } from "./TooltipPage.vue?vue&type=template&id=f4ad25f6&scoped=true"
import script from "./TooltipPage.vue?vue&type=script&lang=js"
export * from "./TooltipPage.vue?vue&type=script&lang=js"

import "./TooltipPage.vue?vue&type=style&index=0&id=f4ad25f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ad25f6"]])

export default __exports__